import { render, staticRenderFns } from "./groupReg.vue?vue&type=template&id=b126e3d0&scoped=true&"
import script from "./groupReg.vue?vue&type=script&lang=js&"
export * from "./groupReg.vue?vue&type=script&lang=js&"
import style0 from "./groupReg.vue?vue&type=style&index=0&id=b126e3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126e3d0",
  null
  
)

export default component.exports